import React, {  useCallback, useEffect, useState } from 'react'
import 'react-quill/dist/quill.snow.css';
import { useDispatch } from 'react-redux'
import { useAppSelector } from '../../../../store/hooks'
import './custom.css'
import Section, { SectionBox, SectionOption } from '../../../../components/Section'
import ReactQuill from 'react-quill'
import getConfiguracaoApp from './Scripts/get';
import TextField from '@mui/material/TextField';
import saveConfig from './Scripts/saveConfig';
import { mdiContentSave, mdiEye } from '@mdi/js';
import { DOMAIN } from '../../../../var_env.';
import createAlert from '../../../../scripts/alert/createAlert';
import { setAlert } from '../../../../store/reducers/alert/alertReducer';
import Button from '../../../../components/Button';



const modules = {
    toolbar: [
      [{ header: [1, 2, false] }],
      ['bold', 'italic', 'underline', 'strike'],
      [{ list: 'ordered' }, { list: 'bullet' }],
      ['blockquote', 'code-block'],
      [{ script: 'sub' }, { script: 'super' }],
      [{ indent: '-1' }, { indent: '+1' }],
      [{ direction: 'rtl' }],
      [{ size: ['small', false, 'large', 'huge'] }],
      [{ color: [] }, { background: [] }],
      [{ font: [] }],
      [{ align: [] }],
      ['clean']
    ]
  };
  
  const formats = [
    'header', 'bold', 'italic', 'underline', 'strike', 'blockquote',
    'list', 'bullet', 'indent', 'link', 'image', 'color', 'background',
    'align', 'script', 'code-block'
  ];

const TextSettings: React.FC = () => {

    const dispatch = useDispatch()
   const [texto, setTexto] = useState(``);
    const [email, setEmail] = useState(``);
const [textoAcompanhado, setTextoAcompanhado] = useState(``);


   const [file, setFile] = React.useState<any>();
    
    const handleFile = async (e: React.ChangeEvent<HTMLInputElement>) => {
        const currentFile = e.target.files
        if (!!currentFile) setFile(currentFile[0])
    }
  

       const handleEnviarArquivo = useCallback(async (arquivo: any) => {
            (async() => {
               

              try{

                    const formData = new FormData()
    
                    formData.append('pdf', file)
         
                    const endpoint = `${DOMAIN}/configuracao-app/upload`
                    const response: any = await fetch(endpoint,{method:'POST',body:formData })
                    const resposta:{sucesso:boolean, msg:string} = await response.json()
                    if(resposta.sucesso) dispatch(setAlert(createAlert('success', 'Arquivo enviado com sucesso')))
                    else dispatch(setAlert(createAlert('error', resposta.msg)))
                  }catch(e:any){
                    dispatch(setAlert(createAlert('error', e.message)))
                  }
                
            })()
        },[file, dispatch])

            const visualizarPDF = (file: File) => {
  const blobUrl = URL.createObjectURL(file);
  window.open(blobUrl, '_blank');
};
        
    const PAGE_NAME = "Protocolos App"


    useEffect(() => {
        (async () => {await getConfiguracaoApp(setTexto, setEmail, setTextoAcompanhado, setFile)})()
    }, [])  
 
    return (
        <>
            <Section name = "NameSection">
                <SectionBox 
                    title = {PAGE_NAME}
                    padding = {true} 
                    right={
                       <>
                      {file && <SectionOption icon = {mdiEye} tooltip = "Vizualizar" onClick = {() => visualizarPDF(file)} />}
                            <input id="fileInput" type="file" style={{ display: 'none' }} name="analise" onChange={(e) => handleFile(e)} required />
                            <label htmlFor="fileInput" className={`btn default`}>{`${file ? file.name : 'Carregar pdf'}`}</label>
                            <SectionOption icon = {mdiContentSave} tooltip = "Salvar" onClick = {() => handleEnviarArquivo(file)} />
                       </>
                    }
                    >

                        <div >

                        <TextField 
                        autoComplete='false'
                        label="Lista de email padrão de envio para o protocolo (Separa por ;)"
                         fullWidth   id="outlined-sla" placeholder="Descrição" value={email} onChange={e => setEmail(e.target.value as string)} />
                   
                   <br/>
                   <br/>
                    <label> Texto padrão para envio do e-mail</label>
                   <ReactQuill 
        theme="snow" 
        value={texto} 
        onChange={setTexto} 
        style={{ fontFamily: 'Arial' }}
      />
      <br/>

      <br/>
                    <label> Texto acompanhado para envio do e-mail</label>
                   <ReactQuill 
        theme="snow" 
        value={textoAcompanhado} 
        onChange={setTextoAcompanhado} 
        style={{ fontFamily: 'Arial' }}
      />
      <br/>
      

<Button label='Salvar Configuração' onClick={() => saveConfig({textoPadrao:texto, emailPadrao: email, textoAcompanhamento: textoAcompanhado}, dispatch)}>Salvar Configuração</Button>


</div>

<br/>

                </SectionBox>
            </Section>
            <>
            </>
        </>
    )
}

export default TextSettings
